import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';

import { UnfinishedGamesService } from '@casinocore/platform/core';
import { CasinoLobbyService } from '@casinocore/platform/core';
import { Observable, firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';

import { TournamentUnfinishedGames, UnfinishedPopupText } from '../slotrace-game.model';
import { UnfinishedGamesPopupComponent } from './unfinished-games-popup.component';

@Injectable({
    providedIn: 'root',
})
export class UnfinishedGamesPopUpService {
    private unfinishedGamesService = inject(UnfinishedGamesService);
    private casinoLobbyService = inject(CasinoLobbyService);
    private dialog = inject(MatDialog);
    destroyRef = inject(DestroyRef);

    async getUnfinishedGamesOfTournament(gameVariantList: string[]): Promise<string[]> {
        try {
            this.unfinishedGamesService.setUnfinishedGames();

            const unfinishedGamesResponse = await firstValueFrom(
                this.unfinishedGamesService.unfinishedFeedFromAllLobbyObservable.pipe(
                    filter((games) => games !== null),
                    takeUntilDestroyed(this.destroyRef),
                ),
            );
            const unfinishedGames: string[] = unfinishedGamesResponse.map((game: any) => game);
            if (!unfinishedGames || unfinishedGames.length === 0) {
                return [];
            }
            return gameVariantList.filter((game) => unfinishedGames.includes(game)).slice(0, 3);
        } catch {
            return [];
        }
    }

    getGamesWithIcon(games: string[]): TournamentUnfinishedGames[] {
        if (!games?.length) return [];
        return games.map((gameId) => ({
            gameId,
            icon: this.casinoLobbyService.getImagePath(gameId, 'square'),
        }));
    }

    openUnfinishedGamesDialog(unfinishedGamesData: TournamentUnfinishedGames[], messages: any): Observable<string | null> {
        const unfinishedPopuUpText: UnfinishedPopupText = {
            preventPopupTitle: messages?.Prevent_Popup_Title,
            preventPopupClose: messages?.Prevent_Popup_Close,
            preventPopupSingleGameDescription: messages?.Prevent_Popup_SingleGame_Description,
            preventPopupMultipleGameDescription: messages?.Prevent_Popup_MultipleGame_Description,
            preventPopupLaunchUnfinishedGame: messages?.Prevent_Popup_Launch_Unfinished_Game,
        };

        const unfinishedGamePopupData = {
            unfinishedGamesData,
            unfinishedPopuUpText,
            preventIconSrc: messages?.Prevent_Icon,
            radialShadowSrc: messages?.Radial_Shadow_Effect,
        };

        const dialogRef = this.dialog.open(UnfinishedGamesPopupComponent, {
            data: unfinishedGamePopupData,
            panelClass: 'unfinishedGames-dialog-panel',
        });

        return dialogRef.afterClosed();
    }
}
